import React from 'react';
import QRCode from "react-qr-code";
import { Modal } from '../../../components/Modal';
import { Button } from '../../../components/Button';
import { Copy, Share2 } from 'lucide-react';

interface QRCodeModalProps {
    isOpen: boolean;
    onClose: () => void;
    url: string;
    tabName: string;
    onCopy: () => void;
    onShare: () => void;
}

export const QRCodeModal: React.FC<QRCodeModalProps> = ({
    isOpen,
    onClose,
    url,
    tabName,
    onCopy,
    onShare
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Share Tab"
        >
            <div className="flex flex-col items-center space-y-6 pt-2 pb-4">
                <div className="p-4 bg-white rounded-2xl shadow-sm border border-border-default">
                    <QRCode
                        size={200}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={url}
                        viewBox={`0 0 256 256`}
                    />
                </div>

                <div className="text-center space-y-1">
                    <p className="font-bold text-text-heading text-lg">{tabName}</p>
                    <p className="text-sm text-text-muted break-all px-4">{url}</p>
                </div>

                <div className="grid grid-cols-2 gap-3 w-full">
                    <Button
                        variant="outline"
                        onClick={onCopy}
                        className="flex items-center justify-center"
                    >
                        <Copy size={16} className="mr-2" />
                        Copy Link
                    </Button>
                    <Button
                        onClick={onShare}
                        className="flex items-center justify-center"
                    >
                        <Share2 size={16} className="mr-2" />
                        Share
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
